import { PRODUCT_VARIANTS_STORE_KEY } from '../constants';
import type { State as ProductVariantsState } from '../reducers/productVariant';

export default (state: GlobalState) => state[PRODUCT_VARIANTS_STORE_KEY] as ProductVariantsState;
